import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade, getPool } from "../../utils/contractHelpers";
import { convertFromWeiEthers } from "../../utils/helpers";
import { USDT_DECIMALS } from "../../utils/constants";


const Platformfee = () => {
    const web3 = useWeb3();

    const PlatformfeeHook = useCallback(
        async (address) => {
            const contract = getTrade(address, web3);
            try {
                const platformfee = await contract.methods.platformFee().call();
                return platformfee
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3]
    );

    const PercentReturnCalculation = useCallback(
        async (address, onlyOracleFeesNeeded) => {
            let contract
            if (onlyOracleFeesNeeded) {
                contract = getPool(address, web3);
            } else {
                contract = getTrade(address, web3);
            }
            try {
                if (onlyOracleFeesNeeded) {
                    // The factory keeps this fee in its base token (USDT, 6 decimals); USDR is 1:1
                    const oraclefixedfee = await contract.methods.oracleFixedFee().call();
                    const oraclefixedfeeFromWei = convertFromWeiEthers(oraclefixedfee, USDT_DECIMALS);
                    return oraclefixedfeeFromWei;
                } else {
                    const oraclefixedfee = await contract.methods.oracleFixedFee().call();
                    const creatorfee = await contract.methods.creatorFee().call();
                    const liquidityfee = await contract.methods.liquidityFee().call();
                    const resolverfee = await contract.methods.resultResolverFee().call();
                    return { oraclefixedfee, creatorfee, liquidityfee, resolverfee };
                }
            } catch (error) {
                console.error("Error fetching fees:", error.message || error);
                throw error;
            }
        },

        [web3]
    );
    return { PlatformfeeHook, PercentReturnCalculation };
};

export default Platformfee;